import { loadStripe } from '@stripe/stripe-js';
import React from 'react'
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

function StripeForm({ amount, parentName, email, paymentMethod, studentDetails }) {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm amount={amount} parentName={parentName} email={email} paymentMethod={paymentMethod} studentDetails={studentDetails} />
    </Elements>
  )
}

export default StripeForm